import { risapi, getAxiosConfig, handleApiError, getAPIFullUrl } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

// API functions are structured identically to VenuesAPI.js and UsersAPI.js
export const getTurfBookings = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/turf-bookings', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const fetchTurfBooking = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/turf-bookings/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createTurfBooking = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        const response = await risapi.post('/api/turf-bookings', formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const updateTurfBooking = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        formData.append('_method', 'put');
        const response = await risapi.post(`/api/turf-bookings/${data.id}`, formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const destroyTurfBooking = async (booking, callback) => {
    try {
        const response = await risapi.delete(`/api/turf-bookings/${booking.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ booking });
        }
    } catch (error) {
        callback(error);
    }
};


/**
 * Fetches the details for a single booking slot.
 * @param {number} slotId The ID of the booking slot.
 * @param {function} callback The function to call with the response.
 */
export const fetchBookingSlot = async (slotId, callback) => {
    try {
        const response = await risapi.get(`/api/booking-slots/${slotId}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};